import { render, staticRenderFns } from "./tabs-item.vue?vue&type=template&id=7da98d5e&scoped=true&"
import script from "./tabs-item.vue?vue&type=script&lang=js&"
export * from "./tabs-item.vue?vue&type=script&lang=js&"
import style0 from "./tabs-item.vue?vue&type=style&index=0&id=7da98d5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da98d5e",
  null
  
)

export default component.exports